import template from './notes.partial.html';

export default () => {

    return {
        restrict: 'E',
        replace: true,
        transclude: true,
        template
    };

};



// WEBPACK FOOTER //
// ./client/app/blocks/notes/notes.directive.js